<template>
  <div>
    <main class="site-content">
      <section class="hero is-danger">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              IceTiger.eu
            </h1>
            <h2 class="subtitle" style="margin-top: 0.5vh;">
              Into the past
            </h2>
            <!-- Internet Explorer User may encounter some problems -->
            <div v-if="isIE" class="notification is-danger">
              <div class="has-text-centered">This site is not optimized for Internet Explorer and may not work like expected!</div>
            </div>
          </div>
        </div>
      </section>
      <loading :show="isLoading" :overlay="isOverlay" ></loading>
      <section class="section">
        <div class="container">
          <div class="notification is-danger" v-if="error">
            <div class="has-text-centered">Event {{ eventID }} was not found or the event api server is currently not available ! Click here for the <router-link to="/event/next">next event</router-link>.</div>
          </div>
          <div class="card" v-else>
            <header class="card-header">
              <p class="card-header-title">
                <router-link to="/event/past">Past Events</router-link>&nbsp;-&nbsp;<router-link to="/event/next">Next Event</router-link>
              </p>
              <a :href="event.url" :title="event.name + ' - ' + event.provider.name" class="card-header-icon" aria-label="event url">
                <span class="icon">
                  <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                </span>
              </a>
            </header>
            <div class="card-content">
              <div class="content">
                <p class="title is-4"><a :href="event.url">{{ event.name }}</a></p>
                <p class="subtitle is-6">{{ event.subtitle }}</p>
                <p>Date: <b>{{ event.from }}</b> - <b> {{ event.to }} </b>
                <br>Location: {{ event.location }}
                <p class="is-size-7">This service was offered by the <a :href="event.provider.homepageUrl">{{ event.provider.name }}</a></p>
              </div>
            </div>
            <footer class="card-footer">
              <div class="card-footer-item default-pointer"> This event has already taken place.</div>
              <a :href="event.provider.footTwitterUrl" class="card-footer-item"> {{event.provider.name}} on Twitter</a>
            </footer>
          </div>
        </div>
      </section>
    </main>
    <vue-headful :title="event.name + ' | IceTiger'" description="Information about past events" keywords="events, icetiger" :url="url"></vue-headful>
  </div>
</template>

<script>
import loading from 'vue-full-loading';

const axios = require('axios');
const API_EntryPoint = "https://api.icetiger.eu/Event/";

export default {
  name: 'Event',
  components: {
    loading
  },
  data () {
    return {
      isIE: /Trident\/|MSIE/.test(window.navigator.userAgent),
      evt: {
        "name": "Event Name",
        "subtitle": "Event Subtitle",
        "url": "#",
        "from": "0000-00-00",
        "to": "0000-00-00",
        "location": "Event Location",
        "provider": {
          "name": "Event Provider",
          "homepageUrl": "#",
          "footTwitterUrl": "#"
        }
      },
      error: false,
      url: 'https://icetiger.eu/event/',
      isLoading: false,
      isOverlay: false
    }
  },
  computed: {
    eventID() {
      return this.$route.params.event_id;
    },
    event: {
      get: function() {
        return this.evt;
      },
      set: function (newVal) {
        this.evt = newVal;
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      axios.get(API_EntryPoint + this.eventID, { timeout: 5000 })
      .then(
        response => {
          this.evt = response.data;
          this.url = 'https://icetiger.eu/event/' + this.eventID;
          this.error = false;
          this.isLoading = false;
        }
      ).catch(
        error => {
          this.url = 'https://icetiger.eu/event/' + this.eventID;
          this.error = true;
          this.isLoading = false;
          console.log (error);
        }
      );
    }
  },
  watch: {
    '$route': 'fetchData'
  }
}

</script>
<style src="@/assets/main.css"></style>



// WEBPACK FOOTER //
// src/components/Event.vue